export { default } from "./InfoIcon";
